<template>
	<el-dialog width="800px" :visible.sync="dialogParams.visible" @close="handleCloseDialog" class="app-dialog-printer" :append-to-body="true"  title="收货地址设置" :center="true" :show-close="false">
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
			<el-form-item label="姓名：" prop="name"><el-input v-model="ruleForm.name" clearable></el-input></el-form-item>
			<el-form-item label="电话：" prop="phone"><el-input v-model="ruleForm.phone" clearable></el-input></el-form-item>
			<el-row type="flex">
				<el-col :span="7">
					<el-form-item label="省：" prop="provinceCode">
						<el-select v-model="ruleForm.provinceCode" placeholder="请选择省" style="width: 150px;" @change="handelChangeProvince">
							<el-option v-for="item in provinces" :key="`$province-${item.code}`" :label="item.name" :value="item.code"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="7">
					<el-form-item label="市：" prop="cityCode">
						<el-select v-model="ruleForm.cityCode" placeholder="请选择市" style="width: 150px;" @change="handelChangeCity">
							<el-option v-for="item in citys" :key="`$city-${item.code}`" :label="item.name" :value="item.code"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="7">
					<el-form-item label="区：" prop="districtCode">
						<el-select v-model="ruleForm.districtCode" placeholder="请选择区" style="width: 150px;">
							<el-option v-for="item in districts" :key="`$district-${item.code}`" :label="item.name" :value="item.code"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-form-item label="详细地址：" prop="address"><el-input v-model="ruleForm.address"></el-input></el-form-item>
		</el-form>
		<div slot="footer">
			<el-button @click="handleCancle()" style="background-color: #E7E7E7;border: none;">取消</el-button>
			<el-button type="primary" style="background-color: #0052D9;border: none;" @click="submitForm('ruleForm')">确认</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import service from '../../service/printer';
	import {
		mapState
	} from 'vuex';
	export default {
		inject: ['reload'],
		data() {
			var validateFloat = (rule, value, callback) => {
				var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;

				if (value === '') {
					callback(new Error('必填字段，请输入值.'));
				} else if (reg.test(value)) {
					callback();
				} else {
					callback(new Error('请输入正确的值.'));
				}
			};
			const validatePhone = (rules, value, callback) => {
				if (!value) {
					return callback(new Error('请输入手机号'));
				}
				let phoneReg = /^1[3456789]\d{9}$/;
				if (!phoneReg.test(value)) {
					return callback(new Error('手机号格式有误(11位手机号)'));
				}
				callback();
			};
			return {
				provinces: [],
				citys: [],
				districts: [],
				dialogParams: {
					title: '',
					visible: false
				},
				ruleForm: {
					id: '',
					name: '',
					phone: '',
					address: '',
					customerId: '',
					provinceCode: '',
					cityCode: '',
					districtCode: '',
					logisticsCompanyId:''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入您的姓名',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}],
					provinceCode: [{
						required: true,
						message: '请选择省',
						trigger: 'blur'
					}],
					cityCode: [{
						required: true,
						message: '请选择市',
						trigger: 'blur'
					}],
					districtCode: [{
						required: true,
						message: '请选择区',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '请输入您的收货地址',
						trigger: 'blur'
					}]
				}
			};
		},
		computed: {
			...mapState({
				userInfo: state => state.userInfo.data
			})
		},
		methods: {
			getProvinces() {
				this.provinces=[]
				service.findRegionByCode('00', 0, res => {
					if (res.code == 200 && res.success) {
						this.provinces = res.data
					}
				})
			},
			handelChangeProvince(val) {
				this.ruleForm.cityCode = ''
				this.citys = []
				this.ruleForm.districtCode = ''
				this.districts = []
				service.findRegionByCode(val, 1, res => {
					if (res.code == 200 && res.success) {
						this.citys = res.data
					}
				})
			},
			handelChangeCity(val) {
				this.ruleForm.districtCode = ''
				this.districts = []
				service.findRegionByCode(val, 2, res => {
					if (res.code == 200 && res.success) {
						this.districts = res.data
					}
				})
			},
			submitForm(formName) {
				this.ruleForm.customerId = this.userInfo.id
				this.$refs[formName].validate(valid => {
					if (valid) {
						if (this.ruleForm.id == '') {
							service.addAddress(this.ruleForm, res => {
								console.log(res)
								this.$message({
									type: 'success',
									message: '添加成功'
								});
								this.handleCloseDialog();
							});
						} else {
							service.updateAddress(this.ruleForm, res => {
								this.$message({
									type: 'success',
									message: '修改成功'
								});
								this.handleCloseDialog();
							});
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			handleCloseDialog() {
				Object.keys(this.ruleForm).forEach(item => {
					this.ruleForm[item] = '';
				});
				this.dialogParams.visible = false;
				this.$emit('success');
			},
			handleCancle() {
				Object.keys(this.ruleForm).forEach(item => {
					this.ruleForm[item] = '';
				});
				this.dialogParams.visible = false;
				this.$emit('cancle');
			},
			handleAdd() {
				this.getProvinces()
				this.dialogParams.visible = true;
			},
			handleUpdate(row) {
				this.getProvinces()
				this.handelChangeProvince(row.provinceCode)
				this.handelChangeCity(row.cityCode)
				Object.assign(this.ruleForm, row)
				this.dialogParams.visible = true;
			},
		}
	};
</script>

<style>
	
</style>
